/**
 * HELIX AI MODEL REGISTRY
 * Single source of truth for all Anthropic model strings.
 *
 * When Anthropic deprecates a version:
 *   1. Update the string here
 *   2. Nothing else changes — every import site gets the new value automatically
 *
 * Standing order (from architecture decision):
 *   SONNET  → proposals, outcomes, diplomatic writing
 *   HAIKU   → routing, classification, extraction, voice-to-JSON
 *   Never use OPUS — nothing warrants it
 */
export const AI_MODELS = {
  SONNET: 'claude-sonnet-4-6',
  HAIKU:  'claude-haiku-4-5-20251001',
} as const;

export type AiModelKey = keyof typeof AI_MODELS;
